import { Tag } from 'lucide-react'
import { Badge } from '@/components/ui'

interface PersonaTagBadgesProps {
  tags?: string[]
  activeTags: string[]
  onToggle: (tag: string) => void
}

export function PersonaTagBadges({ tags, activeTags, onToggle }: PersonaTagBadgesProps) {
  if (!tags || tags.length === 0) return null
  return (
    <>
      {tags.map((tag) => (
        <button
          key={tag}
          type="button"
          onClick={() => onToggle(tag)}
          title={`Filter by "${tag}"`}
          aria-label={`Filter by "${tag}"`}
        >
          <Badge
            variant={activeTags.includes(tag) ? 'default' : 'outline'}
            className="flex items-center gap-1 hover:bg-primary/10"
          >
            <Tag className="w-3 h-3" />
            {tag}
          </Badge>
        </button>
      ))}
    </>
  )
}
